import { gql } from 'apollo-boost';

export const SUBMIT_DAILY_REVIEW_FEEDBACK = gql`
    mutation($data: DailyReviewFeedbackInput!) {
        submitDailyReviewFeedback(data: $data)
    }
`;
